import type { ReactElement } from 'react';

import DentistSearch from '../../components/DentistSearch';

export default function Pesquisa(): ReactElement {
  return <DentistSearch variant="standalone" />;
}
